"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MathQuill = void 0;

var MathQuill = require('exports-loader?window.MathQuill!imports-loader?window.jQuery=jquery!mathquill/build/mathquill.js');

exports.MathQuill = MathQuill;
var MQ = MathQuill.getInterface(2);
var _default = MQ;
exports["default"] = _default;